import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import useAlert from '../../hooks/useAlert';
import FeedbackPopup from './FeedbackPopup';
import { clickTracker, getProjectId, getSubEventType } from '../../lib/common';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

const Statistics = ({ statisticsData, faqId, selectedFaqData }) => {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [selectedType, setSelectedType] = useState('');
  const [setAlert] = useAlert();
  const projectId = getProjectId();
  const [authState] = useAuth();

  const handleReviewClick = async (key, data) => {
    setSelectedType(key);
    setPopupData(data?.popup || {});
    setShowFeedbackPopup(true);
    await clickTracker(`diagnostic_${key}`, `leads_diagnostic_${getSubEventType[faqId] || ''}`);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${key}_review`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
  };

  const handleCloseFeedbackPopup = () => {
    document.body.style.overflow = 'unset';
    setShowFeedbackPopup(false);
  };

  return (
    <>
      <ul className={`${styles.Accordion__StasticsItems} mt-10`}>
        {statisticsData &&
          Object.keys(statisticsData).length > 0 &&
          Object.keys(statisticsData).map(
            (eachKey) =>
              eachKey &&
              eachKey !== '' &&
              statisticsData[eachKey] &&
              Object.keys(statisticsData[eachKey]).length > 0 &&
              Object.keys(statisticsData[eachKey]).map((each, id) => (
                <li
                  className={`${styles.Accordion__StasticsItem} ${
                    statisticsData[eachKey]?.[each]?.hasIssue ? styles.DeActive : styles.Active
                  } whitefill_animate`}
                  key={id}
                >
                  <div className={`${styles.Accordion__StasticsText} `}>
                    <div className={`${styles.Accordion__StasticsTextMain} font12 fw500`}>
                      {statisticsData[eachKey]?.[each]?.display?.title || ''}
                    </div>
                    <div className="font11 fw400 color777">{statisticsData[eachKey]?.[each]?.display?.text || ''}</div>
                  </div>
                  <div
                    tabIndex={0}
                    role="button"
                    onKeyDown={() => {}}
                    onClick={() => handleReviewClick(each, statisticsData[eachKey]?.[each] || {})}
                    className={`${styles.Accordion__StasticsAnchor} ${styles.LeadsHealthIssues__btnbox} font11 fw500 color007 pointer`}
                  >
                    Review
                  </div>
                </li>
              )),
          )}
      </ul>

      {showFeedbackPopup && (
        <FeedbackPopup
          popupData={popupData}
          handleCloseFeedbackPopup={handleCloseFeedbackPopup}
          id="contract"
          selectedType={selectedType}
          faqId={faqId}
          trackerId="diagnostic"
          setAlert={setAlert}
        />
      )}
    </>
  );
};

export default Statistics;

Statistics.propTypes = {
  statisticsData: PropTypes.object,
  faqId: PropTypes.number,
  selectedFaqData: PropTypes.object,
};
